export const version = () => require('../package').version;
